"use client";

import { useState } from "react";
import Image from "next/image";
import styles from "./VideoCarouselCard.module.scss";

export default function VideoThumbnail({
  thumbnail,
  title,
}: {
  thumbnail: string;
  title: string;
  }) {
  
  const [candidateIndex, setCandidateIndex] = useState(0);
  const youtubeThumbnail = thumbnail?.match(
    /^(https:\/\/(?:i\.ytimg\.com|img\.youtube\.com)\/vi\/[^/]+\/)(?:default|mqdefault|hqdefault|sddefault|maxresdefault)\.jpg(?:\?.*)?$/
  );
  const candidates = youtubeThumbnail
    ? [...new Set([
        `${youtubeThumbnail[1]}maxresdefault.jpg`,
        `${youtubeThumbnail[1]}hqdefault.jpg`,
        thumbnail,
      ])]
    : [thumbnail];
  const tryNextThumbnail = () =>
    setCandidateIndex((index) => Math.min(index + 1, candidates.length - 1));

  return (
    <Image
      src={candidates[candidateIndex]}
      alt={title}
      className={styles.thumbnailImage}
      width={560}
      height={315}
      loading="lazy"
      onError={tryNextThumbnail}
      onLoad={(event) => {
        if (youtubeThumbnail && event.currentTarget.naturalWidth <= 120) {
          tryNextThumbnail();
        }
      }}
    />
  );
}
